// @flow

type Action =
  | { type: 'SCRIBE_CLEAR_NOTIFICATION' }
  | { type: 'SCRIBE_SET_NOTIFICATION_TEXT', text: string }
  | { type: 'SCRIBE_SET_NOTIFICATION_PROGRESS', progress: number };

type State = {
  text?: string,
  progress?: number,
};

const initialState = {};

export default function scribeNotifications(
  state: State = initialState,
  action: Action
): State {
  switch (action.type) {
    case 'SCRIBE_CLEAR_NOTIFICATION':
      return {
        ...state,
        text: undefined,
        progress: undefined,
      };

    case 'SCRIBE_SET_NOTIFICATION_TEXT':
      return {
        ...state,
        text: action.text,
      };

    case 'SCRIBE_SET_NOTIFICATION_PROGRESS':
      return {
        ...state,
        progress: action.progress,
      };

    default:
      // eslint-disable-next-line no-unused-expressions
      (action: empty);
      return state;
  }
}
